import _get from 'lodash/get'
import Vue from 'vue'

export default {
  state: {
    users: []
  },
  mutations: {
    SET_KING_USERS (state, users) { // Not WS
      state.users = users
    }
  },
  actions: {
    async REFRESH_KING_USERS ({ commit, rootGetters }) {
      let users = null
      try {
        users = await Vue.api.KING.users.list(null, true)
      } catch (err) {
        Vue.fpuiMessageBlock.error(err)
        console.error(err)
      }
      commit('SET_KING_USERS', users)
    }
  },
  getters: {
    KING_USER_BY_UID (state) {
      return (uid, field = '', fallback) => {
        const user = state.users.find(user => user._id === uid)
        if (!user) return fallback ? uid : null
        if (!field) return user
        return _get(user, field)
      }
    },
    KING_USERS (state) {
      return state.users
    }
  }
}
